const state = {
  parcelList: [],
  addrids: [],
  currAddrid: '',
}

const getters = {
}

const mutations = {
  setParcelList (state, list) {
    state.parcelList = list
  },
  setAddrids (state, list) {
    state.addrids = list
  },
  setCurrAddrid (state, id) {
    state.currAddrid = id
  },
}

const actions = {
  search ({ state, commit, rootState }, params) {
    params = {
      page: 1,
      pageSize: 100,
      addrid: state.currAddrid,
      ...params,
    }
    return rootState.axios.get('/jye/v1frontend/blindbox/search', { params }).then((res) => {
      if (!res.data.error) {
        // const list = []

        // res.data.list.forEach((item, i) => {
        //   // if (typeof item.extraInfo === 'string') {
        //   //   item.extraInfo = JSON.parse(item.extraInfo)
        //   // }
        //   // itemid 同一個只顯示一次
        //   if (!list.find(item2 => item2.tradeItems[0].itemid === item.tradeItems[0].itemid)) {
        //     item.trackingNo = list.length
        //     list.push(item)
        //   }
        // })
        // res.data.list = list
        commit('setParcelList', res.data.list)
      }
      return res
    })
  },
  open ({ state, commit, rootState }, params) {
    params = {
      addrid: state.currAddrid,
      ...params,
    }
    return rootState.axios.get('/jye/v1frontend/blindbox/open', { params })
  },
  giveup ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jye/v1frontend/blindbox/giveup', { params })
  },
  accept ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jye/v1frontend/blindbox/accept', { params })
  },
  exist ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jye/v1frontend/blindbox/exist', { params })
  },
  winners ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jye/v1frontend/blindbox/winners', { params })
  },
  addrids ({ state, commit, rootState }, params) {
    return rootState.axios.get('/jye/v1frontend/blindbox/addrids', { params }).then(res => {
      if (!res.data.error) {
        commit('setAddrids', res.data.model)
        commit('setCurrAddrid', res.data.model[0])
      }
      return res
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
